import React, {Component} from "react";
import {Tab, Tabs} from 'react-bootstrap';
import config from 'react-global-configuration';
import MappedMerchantData from 'components/MasterData/MappedData';
import UnmappedMerchantData from 'components/MasterData/UnMappedData';
import LinkedData from 'components/MasterData/LinkedData';
import MappedBrandData from 'components/MasterData/BrandMappedData';
import UnmappedBrandData from 'components/MasterData/BrandUnmappedData';
import jwt_decode from "jwt-decode";

class MasterData extends Component {
    constructor(props){
        super(props);
        this.state = {
            userType:'',
            file_id: null
        }
    }
    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState(
            {
                      userType:decoded.userType,
                      //file_id: this.state.match.props.id
                  }
        )
    }
    render() {
        console.log("utype");
        console.log(this.state.userType);
        //console.log(this.file_id);
        //let defaultTab
        let hidepane =null;
        if(this.state.userType==='External'){
            // defaultTab = 'apistudio';
            hidepane = (
                <React.Fragment>
                    <Tabs defaultActiveKey="merchantUnmappedData" id="query-builder-tab" >
                    <Tab  eventKey="merchantUnmappedData" title="Unmapped Merchant Data" >
                        <UnmappedMerchantData/>
                    </Tab>
                    <Tab eventKey="merchantMappedData" title="Mapped Merchant Data" >
                        <MappedMerchantData/>
                    </Tab>
                    <Tab  eventKey="brandUnmappedData" title="Brand Unmapped Data" >
                        <UnmappedBrandData/>
                    </Tab>
                    <Tab  eventKey="brandMappedData" title="Brand Mapped Data" >
                        <MappedBrandData/>
                    </Tab>
                    <Tab  eventKey="linkedData" title="Linked Merchant Data to Brand Data" >
                        <LinkedData/>
                    </Tab>
                    </Tabs>
                </React.Fragment>
            );
        }
        if(this.state.userType==='Admin' || this.state.userType==='Internal'){
            //defaultTab = 'datapipeline';
            hidepane = (
                <React.Fragment>
                    <Tabs defaultActiveKey="merchantUnmappedData" id="query-builder-tab" >
                    <Tab  eventKey="merchantUnmappedData" title="Unmapped Merchant Data" >
                        <UnmappedMerchantData/>
                    </Tab>
                    <Tab eventKey="merchantMappedData" title="Mapped Merchant Data" >
                        <MappedMerchantData/>
                    </Tab>
                    <Tab  eventKey="brandUnmappedData" title="Brand Unmapped Data" >
                        <UnmappedBrandData/>
                    </Tab>
                    <Tab  eventKey="brandMappedData" title="Brand Mapped Data" >
                        <MappedBrandData/>
                    </Tab>
                    <Tab  eventKey="linkedData" title="Linked Merchant Data to Brand Data" >
                        <LinkedData/>
                    </Tab>
                    </Tabs>
                </React.Fragment>
            );
        }
        return (
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">Master Data</h4>
                                </div>
                                <div className="content">
                                    {hidepane}
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default MasterData;